var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "acarousel",
      class: {
        "acarousel--ssr": _vm.isSSR,
        "acarousel--auto-play": _vm.settings.autoplay,
        "acarousel--disabled": _vm.settings.unagile,
        "acarousel--fade": _vm.settings.fade && !_vm.settings.unagile,
        "acarousel--rtl": _vm.settings.rtl,
        "acarousel--no-nav-buttons": !_vm.settings.navButtons,
      },
      on: { touchstart: () => {} },
    },
    [
      _c("div", { ref: "list", staticClass: "acarousel__list" }, [
        _c(
          "div",
          {
            ref: "track",
            staticClass: "acarousel__track",
            style: {
              transform: `translate(${_vm.translateX + _vm.marginX}px)`,
              transition: `transform ${_vm.settings.timing} ${_vm.transitionDelay}ms`,
            },
            on: {
              mouseover: function ($event) {
                return _vm.handleMouseOver("track")
              },
              mouseout: function ($event) {
                return _vm.handleMouseOut("track")
              },
            },
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.slidesCloned,
                    expression: "slidesCloned",
                  },
                ],
                ref: "slidesClonedBefore",
                staticClass: "acarousel__slides acarousel__slides--cloned",
              },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "slides",
                staticClass: "acarousel__slides acarousel__slides--regular",
              },
              [_vm._t("default")],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.slidesCloned,
                    expression: "slidesCloned",
                  },
                ],
                ref: "slidesClonedAfter",
                staticClass: "acarousel__slides acarousel__slides--cloned",
              },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.$slots.caption
        ? _c(
            "div",
            { staticClass: "acarousel__caption" },
            [_vm._t("caption")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.settings.unagile && (_vm.settings.navButtons || _vm.settings.dots)
        ? _c("div", { staticClass: "acarousel__actions" }, [
            _vm.settings.navButtons && !_vm.settings.unagile
              ? _c(
                  "button",
                  {
                    ref: "prevButton",
                    staticClass:
                      "acarousel__nav-button acarousel__nav-button--prev",
                    attrs: { disabled: !_vm.canGoToPrev, type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.goToPrev(), _vm.restartAutoPlay()
                      },
                    },
                  },
                  [
                    _vm._t("prevButton", function () {
                      return [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            staticStyle: {
                              "enable-background": "new 0 0 50 50",
                            },
                            attrs: {
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              x: "0px",
                              y: "0px",
                              viewBox: "0 0 50 50",
                              "xml:space": "preserve",
                            },
                          },
                          [
                            _c("line", {
                              staticClass: "ls",
                              attrs: {
                                x1: "16.618",
                                y1: "25",
                                x2: "33.382",
                                y2: "7.895",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              staticClass: "ls",
                              attrs: {
                                x1: "16.618",
                                y1: "25",
                                x2: "33.382",
                                y2: "42.105",
                              },
                            }),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.dots && !_vm.settings.unagile
              ? _c(
                  "ul",
                  { ref: "dots", staticClass: "acarousel__dots" },
                  _vm._l(_vm.countSlides, function (n) {
                    return _c(
                      "li",
                      {
                        key: n,
                        staticClass: "acarousel__dot",
                        class: {
                          "acarousel__dot--current": n - 1 === _vm.currentSlide,
                        },
                        on: {
                          mouseover: function ($event) {
                            return _vm.handleMouseOver("dot")
                          },
                          mouseout: function ($event) {
                            return _vm.handleMouseOut("dot")
                          },
                        },
                      },
                      [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.goTo(n - 1), _vm.restartAutoPlay()
                              },
                            },
                          },
                          [_vm._v("\n          " + _vm._s(n) + "\n        ")]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.settings.navButtons && !_vm.settings.unagile
              ? _c(
                  "button",
                  {
                    ref: "nextButton",
                    staticClass:
                      "acarousel__nav-button acarousel__nav-button--next",
                    attrs: { disabled: !_vm.canGoToNext, type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.goToNext(), _vm.restartAutoPlay()
                      },
                    },
                  },
                  [
                    _vm._t("nextButton", function () {
                      return [
                        _c(
                          "svg",
                          {
                            staticClass: "icon",
                            staticStyle: {
                              "enable-background": "new 0 0 50 50",
                            },
                            attrs: {
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              x: "0px",
                              y: "0px",
                              viewBox: "0 0 50 50",
                              "xml:space": "preserve",
                            },
                          },
                          [
                            _c("line", {
                              staticClass: "ls",
                              attrs: {
                                x1: "16.618",
                                y1: "7.895",
                                x2: "33.382",
                                y2: "25",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              staticClass: "ls",
                              attrs: {
                                x1: "16.618",
                                y1: "42.105",
                                x2: "33.382",
                                y2: "25",
                              },
                            }),
                          ]
                        ),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }